import React, { forwardRef, ReactNode } from 'react'

import cn from 'classnames'
import { Transition } from 'react-transition-group'

import styles from './Overlay.module.scss'

export interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode | ReactNode[]
  isIn?: boolean
}

const Overlay: React.FC<OverlayProps> = forwardRef(
  ({ isIn, children, ...props }: OverlayProps, ref: React.Ref<HTMLDivElement>) => {
    return (
      <Transition
        in={isIn}
        timeout={{
          appear: 0,
          enter: 0,
          exit: 300,
        }}
        mountOnEnter
        unmountOnExit
      >
        {(transitionState) => (
          <div
            ref={ref}
            role="presentation"
            className={cn(
              styles.container,
              transitionState && styles[`container_${transitionState}`],
            )}
            {...props}
          >
            {children}
          </div>
        )}
      </Transition>
    )
  },
)

export default Overlay
